if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = document.getElementById("product-stoc");
      // this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      const variantPicker = this.closest('.product-info').querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy
      );

      // Initialized Cargo Price
      const el_cargoPrice = document.getElementById("product-cargoPrice");
      let productPrice = document.getElementById("discounted-price-with-code");
      productPrice = productPrice.innerText.replace('lei', '').trim()

      const cargoPrice = this.getCargoPrice(productPrice);
      console.log("🚀 ~ ProductInventory ~ initLazySection ~ cargoPrice:", window.currentProduct.price)
      let cargoPriceText = `Cost transport ${cargoPrice} RON`;
      console.log("🚀 ~ ProductInventory ~ initLazySection ~ cargoPriceText:", cargoPriceText)

      // if (Number.parseFloat(window.currentProduct.price) >= 99900) {
      //   cargoPriceText = `Cost transport <span class="stroke-through">${cargoPrice} RON</span> <b class="text-green">GRATUIT</b>`;
      // }

      el_cargoPrice.innerHTML = cargoPriceText;
    }


    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }
    /**
     * Get Carpo Price by product price
     */
    getCargoPrice(productPrice) {
      const price = productPrice.replace(',', '');
      console.log("🚀 ~ ProductInventory ~ getCargoPrice ~ price:", price)

      let cargoPrice = 19;

      // if (price > 0 && price <= 11900) {
      //   cargoPrice = 9;
      // }

      if (price > 11900 && price <= 24900) {
        cargoPrice = 19;
      }

      if (price > 24900 && price <= 39900) {
        cargoPrice = 29;
      }

      if (price > 39900 && price <= 69900) {
        cargoPrice = 39;
      }

      if (price > 69900 && price <= 99900) {
        cargoPrice = 49;
      }
      if (price > 99900) {
        cargoPrice = 69;
      }
      console.log("🚀 ~ ProductInventory ~ getCargoPrice ~ cargoPrice geldii:", cargoPrice)
      return cargoPrice;
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {

      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        console.log("🚀 ~ handleVariantChange ~ evt.detail.variant:", evt.detail.variant)
        window.productPriceBox.selectedVariant = evt.detail.variant.id;
        console.log("🚀 ~ handleVariantChange ~ window.productPriceBox.selectedVariant:", window.productPriceBox.selectedVariant)
        window.reflectProductPrice();
        window.setEstimatedDates(evt.detail.variant);
        // window.installmentsVue.selectedVariant = evt.detail.variant.id;
        window.installmentsVue.setSelectedVariant(evt.detail.variant.id);
        window.setCustomBuyButton(evt.detail.variant);
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
        // Elements
        const el_cargoPrice = document.getElementById("product-cargoPrice");
        if (el_cargoPrice) {
          // Initialized Cargo Price
          const el_cargoPrice = document.getElementById("product-cargoPrice");

          let productPrice = document.getElementById("discounted-price-with-code");
          productPrice = productPrice.innerText.replace('lei', '').trim()

          const cargoPrice = this.getCargoPrice(productPrice);

          let cargoPriceText = `Cost transport ${cargoPrice} RON`;


          // if (Number.parseFloat(window.currentProduct.price) >= 99900) {
          //   cargoPriceText = `Cost transport <span class="stroke-through">${cargoPrice} RON</span> <b class="text-green">GRATUIT</b>`;
          // }

          el_cargoPrice.innerHTML = cargoPriceText;
        }


      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
      let inventoryLevel;
      const el_countDownTimer = document.getElementById("shopify-block-hextom_sales_boost_usb_get_it_by_timer_twrgq9");


      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute('data-inventory-level', inventoryLevel);

        // Determine whether to show the count or not
        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = 'In stoc';
          if (el_countDownTimer) {
            el_countDownTimer.classList.add("hidden");
          }
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel.includes('low')) {
          // this.inventoryNotice.innerText = theme.strings.lowStock;
          //   this.inventoryNotice.innerHTML = ` <div class="in-stock">
          //   <img src="https://adoremobila.myshopify.com/cdn/shop/t/83/assets/checkmark.svg?v=114364156706120143461703594377" alt="">
          //   In Stoc
          // </div>`;
          this.inventoryNotice.innerHTML = `In stoc`;
          if (el_countDownTimer) {
            el_countDownTimer.classList.remove("hidden");
          }
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          // this.inventoryNotice.innerText = theme.strings.noStock;
          this.inventoryNotice.innerText = "In stoc";
        }

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}
